import { BannerVariant } from './types';
import { iconList } from '../Icon/iconList';

export const getVariantIcon = (
  variant: BannerVariant,
): keyof typeof iconList => {
  switch (variant) {
    case 'error':
      return 'triangle-exclamation-outline';
    case 'warning':
      return 'triangle-exclamation-outline';
    case 'info':
      return 'info';
    case 'disabled':
      return 'disable';
    default:
      return 'info';
  }
};
